/* eslint-disable no-restricted-exports, unicorn/no-anonymous-default-export */
import type { RouteLocationNormalized } from "vue-router";

export default (to: RouteLocationNormalized) => to.matched.length === 0;
